import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const buildQuery = (theme: any, query: any, start: any, end?: any) => {
  switch (query) {
    case "up":
      return theme.breakpoints.up(start);
    case "down":
      return theme.breakpoints.down(start);
    case "between":
      return theme.breakpoints.between(start, end);
    default:
      return theme.breakpoints.only(start);
  }
};

export default function useResponsive(query: any, start: any, end?: any) {
  const theme = useTheme();

  return useMediaQuery(buildQuery(theme, query, start, end));
}

export function useWidth() {
  const theme = useTheme();

  const keys = [...theme.breakpoints.keys].reverse();

  return (
    keys.reduce((output: any, key: any) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));

      return !output && matches ? key : output;
    }, null) || "xs"
  );
}
